/**
 * Centralized localStorage key registry.
 *
 * Every localStorage key used by the app MUST be defined here so that
 * tenant-scoped keys are correctly cleared on logout / login.
 *
 * When adding a new key:
 *   1. Add a constant below.
 *   2. If it holds data that differs per tenant (projects, batches, dismissed
 *      guides, etc.), add it to TENANT_SCOPED_KEYS.
 *   3. Use the constant everywhere — never use raw string literals.
 */

// ── User profile (non-sensitive, hydrates UI before /me resolves) ─────
export const USER_KEY = 'migratr_user';
/** Persists across browser restarts when "Remember Me" is checked at login */
export const REMEMBER_ME_KEY = 'migratr_remember_me';

// ── Legacy auth keys (pre-HttpOnly-cookie rollout) ───────────────────
// Kept only so that existing installs can be scrubbed on next logout /
// clearSession.  Nothing should read or write these any more.
export const LEGACY_TOKEN_KEY = 'migratr_token';
export const LEGACY_REFRESH_TOKEN_KEY = 'migratr_refresh_token';

// ── Tenant-scoped (cleared on logout + login) ────────────────────────
export const SELECTED_PROJECT_KEY = 'migratr_selected_project';
export const DISMISSED_GUIDE_KEY = 'migratr_dismissed_guide';

// ── UI preferences (NOT tenant-scoped, persist across accounts) ──────
export const CANVAS_LAYOUT_DENSITY_KEY = 'migratr_canvas_layout_density';
export const INSPECTOR_HEIGHT_KEY = 'migratr_inspector_height_px';

// ── Chat session storage prefix ──────────────────────────────────────
export const CHAT_STORAGE_PREFIX = 'migratr_chat_';

/**
 * Keys that hold data scoped to a specific tenant and must be removed
 * when the user logs out or logs in as a different account.
 */
export const TENANT_SCOPED_KEYS: readonly string[] = [
  SELECTED_PROJECT_KEY,
  DISMISSED_GUIDE_KEY,
] as const;
